// extracted by mini-css-extract-plugin
export default {"saved":"GreenCheckIcon_saved__6oa4f"};